import { Button } from "../shared/button/button";
import { ContainerLogin } from "./styles";
import {
  LinkStyled,
  NormalText,
  TextFieldStyled,
  TitleStyled,
} from "../shared/styles";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Announcement } from "../shared/announcement/announcement";
import {
  getAccountLinkError,
  resetPasswordRequest,
} from "../redux/actions/user.actions";

const MIN_PASSWORD_LENGTH = 10;

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  // El token se lee una vez y se saca de la barra de direcciones/historial.
  const [token] = useState(() => searchParams.get("token") || "");
  const [input, setInput] = useState({ password: "", confirmPassword: "" });
  const [status, setStatus] = useState({
    isLoading: false,
    error: "",
    success: "",
  });

  useEffect(() => {
    if (window.location.search) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  function handleChange(e) {
    setInput((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setStatus((prev) => ({ ...prev, error: "" }));
  }

  function handleSubmit(e) {
    if (e?.type === "keydown" && e.key !== "Enter") {
      return;
    }

    if (!token) {
      setStatus((prev) => ({
        ...prev,
        error: "This link is invalid or has expired. Request a new one.",
      }));
      return;
    }

    if (input.password.length < MIN_PASSWORD_LENGTH) {
      setStatus((prev) => ({
        ...prev,
        error: `The password must be at least ${MIN_PASSWORD_LENGTH} characters long.`,
      }));
      return;
    }

    if (input.password !== input.confirmPassword) {
      setStatus((prev) => ({ ...prev, error: "Passwords don't match." }));
      return;
    }

    setStatus({ isLoading: true, error: "", success: "" });
    resetPasswordRequest(token, input.password)
      .then(() => {
        setInput({ password: "", confirmPassword: "" });
        setStatus({
          isLoading: false,
          error: "",
          success: "Your password was updated. You can now log in.",
        });
      })
      .catch((error) => {
        setStatus({
          isLoading: false,
          error: getAccountLinkError(error),
          success: "",
        });
      });
  }

  return (
    <ContainerLogin>
      <Box margin={"0 auto"}>
        <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <TitleStyled>Choose a new password</TitleStyled>
        <NormalText>
          Enter your new password twice. It must be at least{" "}
          {MIN_PASSWORD_LENGTH} characters long.
        </NormalText>
      </Box>
      {!status.success && (
        <>
          <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
            <TextFieldStyled
              name={"password"}
              placeholder={"New password"}
              type={"password"}
              variant="standard"
              value={input.password}
              InputProps={{
                disableUnderline: true,
              }}
              autoComplete="new-password"
              onChange={handleChange}
              onKeyDown={handleSubmit}
            />
            <TextFieldStyled
              name={"confirmPassword"}
              placeholder={"Confirm new password"}
              type={"password"}
              variant="standard"
              value={input.confirmPassword}
              InputProps={{
                disableUnderline: true,
              }}
              autoComplete="new-password"
              onChange={handleChange}
              onKeyDown={handleSubmit}
            />
          </Box>
          <Button
            label={"Update password"}
            fullWidth
            onClick={handleSubmit}
            buttonStyles={{
              padding: "12px",
              minHeight: "47px",
            }}
            isLoading={status.isLoading}
          />
        </>
      )}
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <LinkStyled href="/" underline="none">
          Back to login
        </LinkStyled>
        {status.error && (
          <LinkStyled href="/forgot-password" underline="none">
            Request a new link
          </LinkStyled>
        )}
      </Box>
      {status.success && (
        <Announcement title={"Success"} description={status.success} type={"info"} />
      )}
      {status.error && (
        <Announcement title={"Error"} description={status.error} type={"error"} />
      )}
    </ContainerLogin>
  );
};
